import { Course } from "@/models/courses.model";
import { QuizResult } from "@/models/quiz.model";
import { Subject } from "rxjs";

export class CourseStore {
  private static $course = new Subject<Course>();
  static course = this.$course.asObservable();

  private static $quiz = new Subject<QuizResult>();
  static quiz = this.$quiz.asObservable();

  static setCourse(value: Course): void {
    CourseStore.$course.next(value);
  }

  static setQuiz(value: QuizResult): void {
    CourseStore.$quiz.next(value);
  }
}
